import type { Balance } from '../data/schemas/balance';

/** Reference speed for variant A linear speedFactor (specs/battle/engine-rules.md). */
export const REFERENCE_SPEED = 50;

const MIN_SPEED_FACTOR = 0.25;

/** Variant A: linear speed factor from derived Speed. */
export function computeSpeedFactor(speed: number, balance: Balance['battle']): number {
  const k = balance.mainCdBaseSpeedMultiplier;
  const raw = 1 + k * ((speed - REFERENCE_SPEED) / REFERENCE_SPEED);
  return Math.max(MIN_SPEED_FACTOR, raw);
}

export function effectiveBaseCd(baseCD: number, balance: Balance['battle']): number {
  return Math.min(balance.maxMainCdSeconds, Math.max(balance.minMainCdSeconds, baseCD));
}

export function tickCooldowns(
  remainingCd: Record<string, number>,
  moveIds: readonly string[],
  dt: number,
  speedFactor: number,
): void {
  for (const moveId of moveIds) {
    const current = remainingCd[moveId] ?? 0;
    remainingCd[moveId] = Math.max(0, current - dt * speedFactor);
  }
}

export function createInitialCooldowns(moveIds: readonly string[]): Record<string, number> {
  const map: Record<string, number> = {};
  for (const id of moveIds) {
    map[id] = 0;
  }
  return map;
}

const CD_EPSILON = 1e-9;

/** Battle-start global gate; decrements by `dt` only (not speedFactor). */
export function tickGlobalCooldown(globalRemainingCd: number, dt: number): number {
  const next = Math.max(0, globalRemainingCd - dt);
  return next <= CD_EPSILON ? 0 : next;
}

export function isCooldownReady(remainingSeconds: number): boolean {
  return remainingSeconds <= CD_EPSILON;
}
